import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "headerBtnBg" }, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ headerBtnBox: true, active: $setup.props.modelValue })
  }, [
    _hoisted_1,
    _withDirectives(_createElementVNode("input", {
      class: "headerBtnCheckbox",
      type: "checkbox",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($props.modelValue) = $event)),
      onInput: _cache[1] || (_cache[1] = $event => _ctx.$emit('update:modelValue', ($event.target as HTMLInputElement).checked))
    }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
      [_vModelCheckbox, $props.modelValue]
    ])
  ], 2 /* CLASS */))
}